/**
 * 后台管理
 */
const App = () => import('@/module/index/layout/App.vue')
const warningMonitor = () => import('@/module/index/pages/backstage/warningMonitor.vue')
const warningMonitorDetail = () => import('@/module/index/pages/backstage/warningMonitorDetail.vue')

export default {
  path: '/backstage',
  component: App,
  redirect: '/backstage/warning',
  meta: {
    title: '后台管理-预警配置-海南涉外民商事法庭案件多元化解平台',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/backstage/warning',
    component: warningMonitor,
    meta: {
      title: '后台管理-预警配置-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/backstage/warning/:type/:id',
    component: warningMonitorDetail,
    meta: {
      title: '后台管理-预警配置-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/backstage/warning/:type',
    component: warningMonitorDetail,
    meta: {
      title: '后台管理-新增预警配置-海南涉外民商事法庭案件多元化解平台'
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/backstage.js